import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit/typography';

import { ETransportType } from '../../types/transportType';
import { FromUndergroundTime } from './parts/FromUndergroundTime';
import { UndergroundIcon } from './parts/UndergroundIcon';

import * as styles from './styles.css';

interface IUndergroundProps {
  lineColor: string;
  name: string;
  transportType?: ETransportType | null;
  timeTo: string;
  regionId: number | null;
}

export function Underground({ lineColor, name, transportType, timeTo, regionId }: IUndergroundProps) {
  return (
    <div className={styles['underground']}>
      <div className={styles['underground-station']}>
        {lineColor && <UndergroundIcon lineColor={lineColor} regionId={regionId} />}
        <InlineText2>{`м. ${name}`}</InlineText2>
      </div>
      {transportType && <FromUndergroundTime transportType={transportType} timeTo={timeTo} />}
    </div>
  );
}
